/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { useLocale } from "@epic-mw/i18n";
import TimeAgo from "javascript-time-ago";
import { useMemo } from "react";

import { CosmosText } from "@components/elements";
import { dateToTimeAgoShort } from "@components/utils/dateFormatters";
import { cx, css } from "@panda/css";
import { hstack } from "@panda/patterns";
import { CosmosElementLearnImageCardSourceFragment } from "@cosmos/hygraph-schema";

export type SourceProps = CosmosElementLearnImageCardSourceFragment & {
	className?: string;
};

export const Source = ({ author, timestamp, className }: SourceProps): React.JSX.Element => {
	const locale = useLocale();
	const timeAgo = useMemo(() => new TimeAgo(locale), [locale]);
	const text = [];

	if (author) {
		text.push(author);
	}
	if (timestamp) {
		const safeTimestamp = typeof timestamp === "string" ? timestamp : String(timestamp);
		text.push(dateToTimeAgoShort(safeTimestamp, timeAgo));
	}

	return (
		<div
			className={cx(
				"reactions",
				hstack({
					alignItems: "center",
					gap: "eds.dimension.20",
				}),
				css({ flexGrow: 0 }),
				className,
			)}
		>
			<CosmosText variant="uiSM" color="eds.text.secondary">
				{text.join(" · ")}
			</CosmosText>
		</div>
	);
};
